import Glide from '../../../js/glide.min.js';

document.addEventListener('DOMContentLoaded', () => {
	const sliderBlocks = document.querySelectorAll('.gallery-block');
	
	sliderBlocks?.forEach(sliderBlock => {
		if (sliderBlock) {			
			const glide = new Glide(sliderBlock, {
				type: 'carousel',
				startAt: 0,
				perView: 1,
				gap: 20,
				focusAt: 'center',
			});
		
			glide.mount();
		
			const prevButton = sliderBlock.querySelector('.glide__arrow--prev');
			const nextButton = sliderBlock.querySelector('.glide__arrow--next');
			const current = sliderBlock.querySelector('.gallery-block__counter-current');
			const caption = sliderBlock.querySelector('.gallery-block__caption');
		
			const updateCaption = () => {
				const activeSlide = document.querySelector('.glide__slide--active');
				const captionText = activeSlide.getAttribute("data-caption");
				
				if (caption) {
					caption.textContent = captionText || '';
				}
			};
		
			// Event listeners for the navigation buttons
			if (prevButton && nextButton) {
			prevButton.addEventListener('click', () => {
				glide.go('&lt;');
				current.textContent = glide.index + 1;
				updateCaption();
			});
			nextButton.addEventListener('click', () => {
				glide.go('&gt;');
				current.textContent = glide.index + 1;
				updateCaption();
			});
			}
		
			// Listen to glide changes and update counter and caption automatically
			glide.on('run.after', () => {
				if (current) {
					current.textContent = glide.index + 1;
				}
				updateCaption();
			});

			updateCaption();
		}
	});
});

